var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroceryList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 18.8227C7.96056 18.8227 8.33366 18.4496 8.33366 17.9893C8.33366 17.5291 7.96056 17.156 7.50033 17.156C7.04009 17.156 6.66699 17.5291 6.66699 17.9893C6.66699 18.4496 7.04009 18.8227 7.50033 18.8227Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 18.8227C17.1266 18.8227 17.4997 18.4496 17.4997 17.9893C17.4997 17.5291 17.1266 17.156 16.6663 17.156C16.2061 17.156 15.833 17.5291 15.833 17.9893C15.833 18.4496 16.2061 18.8227 16.6663 18.8227Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 1.32269H4.16634L6.39967 12.481C6.47588 12.8647 6.6846 13.2093 6.9893 13.4546C7.29399 13.6999 7.67526 13.8302 8.06634 13.8227H16.1663C16.5574 13.8302 16.9387 13.6999 17.2434 13.4546C17.5481 13.2093 17.7568 12.8647 17.833 12.481L19.1663 5.48936H4.99967",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.48938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceryList);
export default __webpack_public_path__ + "static/media/grocery-list.50e95b5631a249501daee097e09612d5.svg";
export { ForwardRef as ReactComponent };